import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from 'src/app/shared/snackbar.service';
import { CustomValidators } from 'src/app/shared/validators';
import { CustomErrorStateMatcher } from '../../../customer-profile/customer-profile.component';
import { OrganizationService } from '../organization.service';

@Component({
  selector: 'app-organization-list-expiration-date-dialog',
  templateUrl: 'organization-list-expiration-date-dialog.component.html',
})
export class OrganizationListExpirationDateDialogComponent implements OnInit {
  formGroup = new FormGroup(
    {
      expirationDate: new FormControl(null, Validators.required),
    },
    {
      updateOn: 'change',
      validators: CustomValidators.Form,
    },
  );
  errorStateMatcher = new CustomErrorStateMatcher();
  minDate: Date;

  constructor(
    private snackbar: SnackbarService,
    private translate: TranslateService,
    private organizationService: OrganizationService,
    public dialogRef: MatDialogRef<OrganizationListExpirationDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 1);
    if (this.data.expirationDate) {
      this.formGroup.controls.expirationDate.setValue(new Date(this.data.expirationDate));
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  async submit(): Promise<void> {
    const expirationDate = this.formGroup.value.expirationDate;
    // Sadly JS Date parser is ignoring timezone with / format
    let formattedExpirationDate = null;
    if (expirationDate) {
      formattedExpirationDate = new Date(
        Date.UTC(
          expirationDate.getFullYear(),
          expirationDate.getMonth(),
          expirationDate.getDate(),
          expirationDate.getHours(),
          expirationDate.getMinutes(),
          expirationDate.getSeconds(),
        ),
      );
    }
    this.organizationService.setExpirationDate(this.data.organizations, formattedExpirationDate).then(
      (response) => {
        if (response.updated !== 0) {
          this.dialogRef.close({ count: response.updated });
        }
      },
      (error) => {
        if (error.status === 400) {
          this.snackbar.error(this.translate.instant('error.wrongData'));
        }
      },
    );
  }
}
